import React, { useState } from 'react';
import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { Button } from 'primereact/button';
import { saveNewExamType } from '../operations/save-new-exam-type';

interface AddNewExamTypeDialog {
  onHide: () => any;
}
export const AddNewExamTypeDialog: React.FC<AddNewExamTypeDialog> = ({
  onHide,
}) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handeOnApprove = async () => {
    await saveNewExamType(name, setLoading, onHide);
  };

  return (
    <div>
      <EditText onChange={setName} value={name} title={'שם סוג המבחן'} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={handeOnApprove}
          loading={loading}
          style={{ height: '30px' }}
          label={'אישור'}
        />
      </div>
    </div>
  );
};
